var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuanteralogoicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 192,
    height: 180
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202 16H10V196H202V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9989 58.05L87.8979 57.876V16L88.1979 15.827L166.292 60.823V61.169L129.959 82.11H129.76L87.9989 58.05Z",
    fill: "url(#paint0_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.192 61L129.859 81.937L88.0996 57.876V16L166.192 61Z",
    fill: "url(#paint1_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76 130.23L129.659 130.058V81.937L129.76 81.764L166.093 60.823L166.393 60.996V150.999L166.093 151.172L129.76 130.23Z",
    fill: "url(#paint2_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.192 61V151L129.859 130.059V81.937L166.192 61Z",
    fill: "url(#paint3_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8979 196V154.124L87.9989 153.951L129.76 129.885H129.959L166.292 150.826V151.172L88.1979 196.173L87.8979 196Z",
    fill: "url(#paint4_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.192 151L88.0996 196V154.124L129.86 130.058L166.192 151Z",
    fill: "url(#paint5_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 151.172V150.826L46.2389 129.885H46.4379L88.1979 153.951L88.2989 154.124V196L87.9989 196.173L9.8999 151.172Z",
    fill: "url(#paint6_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1 154.124V196L10 151L46.339 130.059L88.1 154.124Z",
    fill: "url(#paint7_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 150.999V60.996L10.0998 60.823L46.4378 81.764L46.5388 81.937V130.058L46.4378 130.23L10.0998 151.172L9.7998 150.999Z",
    fill: "url(#paint8_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.339 81.937V130.058L10 151V61L46.339 81.937Z",
    fill: "url(#paint9_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2389 82.11L9.8999 61.169V60.823L87.9989 15.827L88.2989 16V57.876L88.1979 58.05L46.4379 82.11H46.2389Z",
    fill: "url(#paint10_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1 16V57.876L46.339 81.937L10 61L88.1 16Z",
    fill: "url(#paint11_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.829 192.583L129.76 171.872V171.524L165.829 150.814H166.028L202.1 171.524V171.872L166.028 192.583H165.829Z",
    fill: "url(#paint12_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.894 182.053L165.929 192.409L183.965 182.053L202 171.7L183.965 161.345L165.929 150.99L147.894 161.345L129.859 171.7L147.894 182.053Z",
    fill: "url(#paint13_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.929 151.219L129.959 171.872L129.659 171.698V130.278L129.76 130.104L165.829 109.395H166.028L202.1 130.104L202.2 130.278V171.698L201.9 171.872L165.929 151.219Z",
    fill: "url(#paint14_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.894 161.343L165.929 150.988L183.965 161.343L202 171.7V130.28L183.965 119.925L165.929 109.57L147.894 119.925L129.859 130.28V171.7L147.894 161.343Z",
    fill: "url(#paint15_linear_30_111)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8529 127.164L63.7119 120.164V119.818L87.9989 105.824H88.1979L112.479 119.818V120.164L88.1979 134.158H87.9989L75.8529 127.164Z",
    fill: "#1A4896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.952 126.991L88.1 133.985L100.24 126.991L112.381 119.991L100.239 113L88.1 106L75.953 113L63.813 119.994L75.952 126.991Z",
    fill: "#1A4896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0988 106.228L63.9108 120.164L63.6108 119.991V92.003L63.7118 91.83L87.9988 77.836H88.1978L112.479 91.83L112.58 92.003V119.991L112.28 120.164L88.0988 106.228Z",
    fill: "#B2D5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.952 113L88.1 106L100.24 113L112.381 119.994V92L100.24 85L88.1 78L75.953 85L63.813 92V119.987L75.952 113Z",
    fill: "#B2D5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6108 119.991V92.003L63.7118 91.83L87.9988 77.836L88.2988 78.01V105.997L88.1978 106.17L63.9108 120.164L63.6108 119.991Z",
    fill: "#3F79D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.952 113L88.1 106V78.01L75.953 85.01L63.813 92.01V120L75.952 113Z",
    fill: "#3F79D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_111",
    x1: 96.7319,
    y1: 31.165,
    x2: 140.423,
    y2: 71.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_111",
    x1: 96.7916,
    y1: 31.221,
    x2: 140.315,
    y2: 71.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1665C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_111",
    x1: 148.026,
    y1: 71.444,
    x2: 148.026,
    y2: 150.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1665C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_111",
    x1: 148.026,
    y1: 71.577,
    x2: 148.026,
    y2: 150.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1665C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30_111",
    x1: 89.6019,
    y1: 165.626,
    x2: 130.997,
    y2: 160.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30_111",
    x1: 89.7766,
    y1: 165.603,
    x2: 131.013,
    y2: 160.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_30_111",
    x1: 37.5409,
    y1: 145.774,
    x2: 79.1599,
    y2: 170.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A85E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A0ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_30_111",
    x1: 37.62,
    y1: 145.821,
    x2: 79.08,
    y2: 170.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A85E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57A0ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_30_111",
    x1: 28.1698,
    y1: 81.444,
    x2: 28.1698,
    y2: 130.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A85E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_30_111",
    x1: 28.17,
    y1: 81.538,
    x2: 28.17,
    y2: 130.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A85E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_30_111",
    x1: 77.7979,
    y1: 28.429,
    x2: 36.4869,
    y2: 72.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_30_111",
    x1: 77.748,
    y1: 28.484,
    x2: 36.596,
    y2: 72.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1274DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_30_111",
    x1: 165.93,
    y1: 150.814,
    x2: 165.93,
    y2: 192.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_30_111",
    x1: 165.929,
    y1: 150.99,
    x2: 165.929,
    y2: 192.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_30_111",
    x1: 129.249,
    y1: 145.854,
    x2: 203.974,
    y2: 138.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_30_111",
    x1: 129.437,
    y1: 145.848,
    x2: 203.772,
    y2: 138.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D5F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuanteralogoicon);
export default __webpack_public_path__ + "static/media/quanteralogoicon.af105d60dac979d8e40c7d6ebee4fc78.svg";
export { ForwardRef as ReactComponent };